import { useState, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import ReactTooltip from 'react-tooltip'
import { Container, NavItem, Menu, MenuItem, Label } from './styles'

export default function DropdownMenu ({
  id,
  icon,
  label = '',
  items = [],
  position = 'right'
}) {
  const [isOpen, setIsOpen] = useState (false)
  const menuRef = useRef  (null)
  const navigate = useNavigate ()

  const toggleMenu = () => setIsOpen (!isOpen)

  const handleClickOutside = event => {
    if (menuRef.current && !menuRef.current.contains (event.target)) {
      setIsOpen (false)
    }
  }

  useEffect (() => {
    document.addEventListener ('mousedown', handleClickOutside)
    return () => document.removeEventListener ( 'mousedown', handleClickOutside)
  }, [])

  const handleItemClick = item => {
    if (item.path) {
      navigate (item.path)
    } else if (item.href) {
      window.open (item.href, '_blank', 'noopener,noreferrer')
    } else if (item.onClick) {
      item.onClick ()
    }
    setIsOpen (false)
  }

  return (
    <Container ref={menuRef}>
      <NavItem onClick={toggleMenu} data-for={id} data-tip>
        {icon}
      </NavItem>
      <Menu isOpen={isOpen} position={position}>
        {items.map ((item, index) => (
          <MenuItem key={index} onClick={() => handleItemClick (item)}>
            {item.label}
          </MenuItem>
        ))}
      </Menu>
      {id && (
        <ReactTooltip
          id={id}
          effect='solid'
          place='right'
          backgroundColor='#252525'
          tooltipRadius='10'
        >
          <Label>{label}</Label>
        </ReactTooltip>
      )}
    </Container>
  )
}
